import { render, staticRenderFns } from "./AppImagePreview.vue?vue&type=template&id=06fb2f45&scoped=true&"
import script from "./AppImagePreview.vue?vue&type=script&lang=ts&"
export * from "./AppImagePreview.vue?vue&type=script&lang=ts&"
import style0 from "./AppImagePreview.vue?vue&type=style&index=0&id=06fb2f45&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06fb2f45",
  null
  
)

export default component.exports